import { Block, component } from '../../../scripts/core/Component'
import { Form } from '../form/index'

@component('dialog')
class Dialog extends Block {
    
  constructor (context) {
    super(context)
    
    this.closeElement = this.element('close');
    this.closeElement.list.forEach((item) => {
      item.el.addEventListener('click', this.closeBtnClickHandler.bind(this));
    })

    this.forms = this.list(Form)
    
    this._openHandlers = []
    this._closeHandlers = []
  }

  open() {
    this.modifier('closed').off();
    this._openHandlers.forEach((handler) => handler.call(this))
  }

  close() {
    this.modifier('closed').on();
    this._closeHandlers.forEach((handler) => handler.call(this))
  }

  closeBtnClickHandler(e) {
    e.preventDefault();
    this.close();
  }
  
  onOpen(handler) {
    if(typeof handler !== 'function') {
      throw new Error('Handler must be a function')
    }

    this._openHandlers.push(handler)
  }
  
  onClose(handler) {
    if(typeof handler !== 'function') {
      throw new Error('Handler must be a function')
    }

    this._closeHandlers.push(handler)
  }
  
  resetInnerForms() {
    this.forms.forEach((form) => {
      form.reset()
    })
  }
}

export {
  Dialog
}



// WEBPACK FOOTER //
// ./components/ui/dialog/index.js